import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';

export const EditButton = styled(IconButton)`
  position: absolute !important;
  right: 0;
  top: 0;
`;

export const DotsVertIcon = styled(MoreVertIcon)`
  ${(props) => (props.color ? `color: ${props.color}` : 'color: white')};
`;
